import { PaginaRelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/model/PaginaRelatorioAM";
import { PlanoAcaoRAM } from "@/contexts/fiscalizacao/relatorioAM/model/PlanoAcaoRAM";
import { RelatorioAM } from "@/contexts/fiscalizacao/relatorioAM/model/RelatorioAM";
import { SituacaoParecerRAM } from "@/contexts/fiscalizacao/relatorioAM/model/SituacaoParecerRAM";
import { api } from "@/shared/api/api";
import { getBlob } from "@/shared/api/getBlob";

const BASE = "/relatorios-monitoria-auditoria";

export interface ListarRelatoriosAMParams {
  page: number;
  estabelecimentoId: number;
  situacao?: string;
}

export const createRelatorioAMApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };
  const multipart = { ...headers, "Content-Type": "multipart/form-data" };

  const submit = async (formData: FormData) => {
    const { data } = await api.post<RelatorioAM>(BASE, formData, {
      headers: multipart,
    });
    return data;
  };

  const update = async (formData: FormData, id: number) => {
    const { data } = await api.put<RelatorioAM>(`${BASE}/${id}`, formData, {
      headers: multipart,
    });
    return data;
  };

  const cancelar = async (id: number, motivo: string) => {
    await api.patch(`${BASE}/${id}/cancelar`, { motivo }, { headers });
  };

  const getById = async (id: number) => {
    const { data } = await api.get<RelatorioAM>(`${BASE}/${id}`, { headers });
    return data;
  };

  const list = async (params: ListarRelatoriosAMParams) => {
    const { data } = await api.get<PaginaRelatorioAM>(BASE, {
      headers,
      params: {
        ...params,
        size: 20,
        page: params.page - 1,
      },
    });
    return data;
  };

  const getAnexo = (nomeUpload: string) =>
    getBlob(`${BASE}/anexo/${nomeUpload}`, { headers });

  const submitPlanoAcao = async (relatorioId: number, formData: FormData) => {
    const { data } = await api.post(
      `${BASE}/${relatorioId}/planos-acao`,
      formData,
      { headers: multipart }
    );
    return data;
  };

  const getAnexoPlanoAcao = (nomeUpload: string) =>
    getBlob(`${BASE}/anexo-plano-acao/${nomeUpload}`, { headers });

  const getPlanosAcaoByItemId = async (itemId: number) => {
    const { data } = await api.get<PlanoAcaoRAM[]>(
      `${BASE}/${itemId}/planos-acao`,
      { headers }
    );
    return data;
  };

  const submitParecer = async (
    planoAcaoId: number,
    content: { situacaoParecer: SituacaoParecerRAM; descricaoParecer: string }
  ) => {
    await api.patch(`${BASE}/plano-acao/${planoAcaoId}/parecer`, content, {
      headers,
    });
  };

  const removerParecer = async (planoAcaoId: number) => {
    await api.patch(
      `${BASE}/plano-acao/${planoAcaoId}/parecer/remover`,
      {},
      { headers }
    );
  };

  return {
    submit,
    update,
    cancelar,
    getById,
    list,
    getAnexo,
    submitPlanoAcao,
    getAnexoPlanoAcao,
    getPlanosAcaoByItemId,
    submitParecer,
    removerParecer,
  };
};
